/**
 * The /community search schema, in its own module so the /chat route can share it without
 * importing another route file (which the router's code splitting doesn't allow).
 */
import { z } from 'zod';

export const communitySearchSchema = z.object({
  tab: z.enum(['feed', 'chats', 'directory', 'events', 'rewards']).optional(),
  // Groups replaced the old Internal (team) tab. An old link or bookmark with
  // `filter=internal` must not throw — it maps to the tab that replaced it.
  filter: z
    .preprocess(
      (v) => (v === 'internal' ? 'groups' : v),
      z.enum(['all', 'groups', 'external', 'dms']),
    )
    .optional(),
  community: z.string().uuid().optional(),
  // Selected channel on the Feed tab. In the URL so that leaving the feed and
  // coming back — history.back() from a recording, most visibly — returns to the
  // channel you were in instead of the all-channels feed. Distinct from
  // `community` above, which selects the TIER, not the channel.
  channel: z.string().uuid().optional(),
  conversation: z.string().uuid().optional(),
  // Deep-link to a specific message inside a conversation (push-notification target).
  message: z.string().uuid().optional(),
  // Multi-select pod filter as comma-separated string, e.g. "2,3".
  // Empty / missing = no filter (show everything). Parsed into a
  // PodNumber[] inside Community.tsx. Null-pod content is included
  // only when the parsed list contains pod 3 (the entry-level default).
  pods: z.string().regex(/^[1-3](,[1-3])*$/).optional(),
});
